export enum RoutePaths {
	USERS = "/users",
	USERS_NEW = "/users/new",
	USERS_EDIT = "/users/:id/edit",
	USERS_NOTIFY = "/users/:id/notify",
	USERS_NOTIFY_BULK = "/users/notify",
	SELLER_SERVICES = "/services",
	SELLERS_SERVICES_NEW = "/services/new",
	SELLERS_SERVICES_EDIT = "/services/:id/edit",
	SERVICE_REVIEWS = "/services/service-reviews",
	VOUCHERS = "/vouchers",
	VOUCHERS_ADD_NEW = "/vouchers/addNew",
	SELLERS = "/sellers",
	SELLERS_EDIT = "/sellers/edit",
	CATEGORIES = "/clusters",
	CATEGORIES_ADD_NEW = "/clusters/addNew",
	MICROSITES = "/microsites",
	MICROSITES_ADD_NEW = "/microsites/addNew",
	SURVEYS = "/surveys",
	SURVEYS_NEW = "/surveys/new",
	SURVEYS_EDIT = "/surveys/:id/edit",
	SURVEY_SECTIONS_NEW = "/survey/sections/new",
	SURVEY_SECTIONS_EDIT = "/survey/sections/:id/edit",
	// SIGN_UP = "/sign-up",
	SIGN_IN = "/sign-in",
	FORGOT = "/forgot",
	CALENDAR = "/calendar",
	SETTINGS = "/settings",
	TIPS = "/tips",
	TIPS_ADD_NEW = "/tips/addNew",
	TRANSACTIONS = "/transactions",
	TRANSACTIONS_EDIT = "/transactions/edit",
	MARKETPLACES = "/marketplaces",
	REPORTS = "/reports",
	BILLING = "/billing",
	B2B = "/b2b",
	BILLING_TRANSACTIONS = "/billing/transactions",
	PAYMENTS = "/payments",
	TOURNAMENTS = "/tournaments",
	TOURNAMENT_MEMBERS = "/tournaments/members",
	COMPANY_EXCEL = "/company-excel"
}
